import React from 'react';
import Link from './Link';

export default function({ label, className, locale }) {
    return (
        <Link
            to={`/files/${
                locale === 'ru' ? 'COVID-19_rus.pdf' : 'COVID-19_eng.pdf'
            }`}
            className={'button ' + className}
        >
            {label}
        </Link>
    );
}



// WEBPACK FOOTER //
// ./src/components/Covid19UpdateButton.js